import { useSelector } from 'react-redux';
import { resolveAdvisorPrefillPolicy } from '@shared';
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';
import { selectFeatureFlags } from '@/model/selectors';

export function useAdvisorPrefillPolicy() {
  const advisorFeatureFlags = useSelector(selectFeatureFlags);
  const { flags: appConfigFlags } = useFeatureFlags();
  return resolveAdvisorPrefillPolicy({ advisorFeatureFlags, appConfigFlags });
}

export function useIsPerClientInviteLinkEnabled() {
  return useAdvisorPrefillPolicy().enabled;
}
